import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../../services';
import { FailedMessagesEndpoint } from '../../constants/failed-messages-endpoint';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { Sc4FailedMessagesListSearchCriteria } from '../../models';
import { isEmpty } from 'lodash';
import { removeEmptyValueFromObj } from '../../../../../../common';

@Injectable({
  providedIn: 'root',
})
export class Sc4FailedMessagesExportService {
  constructor(private http: WrapperHttpService) {}

  startExportToFile({
    searchCriteria,
    reportName,
  }: {
    searchCriteria: Sc4FailedMessagesListSearchCriteria;
    reportName: string;
  }): Observable<void> {
    const { size: _size, page: _page, ...rest } = searchCriteria;
    const url = `${API_URL}${FailedMessagesEndpoint.Base}${FailedMessagesEndpoint.Sc4}${FailedMessagesEndpoint.Exports}`;
    const transactionDateTime = removeEmptyValueFromObj({
      ...rest.transactionDateTime,
      start: rest.transactionDateTime?.start ? new Date(rest.transactionDateTime.start).getTime() : null,
      end: rest.transactionDateTime?.end ? new Date(rest.transactionDateTime.end).getTime() : null,
    });
    const filter = removeEmptyValueFromObj({
      ...rest,
      transactionDateTime: isEmpty(transactionDateTime) ? null : transactionDateTime,
    });
    return this.http.withLoading().post<void>(url, { reportName, filter });
  }
}
